import React from 'react';
import {
  Text, TouchableOpacity,
} from 'react-native';

export const Button = ({
  title,
  width,
  height,
  titleColor,
  bgColor,
  signIn = () => {

  },
}) => {
  return (
    <TouchableOpacity
      style={{
        backgroundColor: bgColor,
        alignItems: 'center',
        justifyContent: 'center',
        height: 46,
        borderRadius: 10,
      }}
      onPress={signIn}
    >
      <Text style={{ color: titleColor, textAlign: 'center', fontWeight: 'bold' }}>{title}</Text>
    </TouchableOpacity>

  );
};
